document.addEventListener('DOMContentLoaded', function () {
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelectorAll('[data-menu-close]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function openMenu() {
    mobileNav.setAttribute('data-open', '');
    mobileNav.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    mobileNav.removeAttribute('data-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
  }
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', openMenu);
    menuClose.forEach(function (btn) { btn.addEventListener('click', closeMenu); });
  }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchBar.hasAttribute('data-open');
      if (isOpen) {
        searchBar.removeAttribute('data-open');
        searchBar.setAttribute('aria-hidden', 'true');
      } else {
        searchBar.setAttribute('data-open', '');
        searchBar.setAttribute('aria-hidden', 'false');
        var input = searchBar.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartDrawer = document.getElementById('CartDrawer');
  var cartCloseEls = document.querySelectorAll('[data-cart-close]');
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  cartCloseEls.forEach(function (btn) { btn.addEventListener('click', closeCart); });

  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImage = document.getElementById('ProductMainImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        // The main image renders with a srcset/sizes pair for responsive
        // loading. Browsers keep using srcset over a plain .src change, so
        // it has to be cleared here or clicking a thumbnail never visibly
        // swaps the image.
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumb.getAttribute('data-src');
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  document.body.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = cart.item_count;
        openCart();
      })
      .catch(function () { form.submit(); });
  });
});

/* Mobile storefront hardening — consolidated from mobile-fixes.js. */
(function () {
  'use strict';

  var mobileNav = document.querySelector('[data-mobile-nav]');
  var cartDrawer = document.getElementById('CartDrawer');
  var lastFocused = null;

  function isOpen(el) {
    return !!(el && el.hasAttribute('data-open'));
  }

  function syncOverlayState() {
    var overlayOpen = isOpen(mobileNav) || isOpen(cartDrawer);
    document.body.classList.toggle('pb-overlay-open', overlayOpen);
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.removeAttribute('data-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  function focusDialogClose(el) {
    if (!el || !isOpen(el)) return;
    var close = el.querySelector('[data-menu-close], [data-cart-close]');
    if (close && typeof close.focus === 'function') close.focus({ preventScroll: true });
  }

  function observeOverlay(el) {
    if (!el || !('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'data-open') return;
        syncOverlayState();
        if (isOpen(el)) {
          lastFocused = document.activeElement;
          window.requestAnimationFrame(function () { focusDialogClose(el); });
        } else if (!isOpen(mobileNav) && !isOpen(cartDrawer) && lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
          lastFocused = null;
        }
      });
    });
    observer.observe(el, { attributes: true, attributeFilter: ['data-open'] });
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function refreshCartDrawer() {
    if (!cartDrawer || !isOpen(cartDrawer)) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        var body = document.getElementById('CartDrawerBody');
        var subtotal = cartDrawer.querySelector('.cart-drawer__subtotal span:last-child');
        var count = document.querySelector('[data-cart-count]');

        if (count) count.textContent = cart.item_count;
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
        if (!body) return;

        body.innerHTML = '';

        if (!cart.items || !cart.items.length) {
          var empty = document.createElement('p');
          empty.className = 'cart-drawer__empty';
          empty.textContent = "Your bag is empty. Time to spoil someone's Frenchie.";
          body.appendChild(empty);
          return;
        }

        cart.items.forEach(function (item) {
          var row = document.createElement('div');
          row.className = 'cart-drawer__item';

          if (item.image) {
            var image = document.createElement('img');
            image.src = item.image;
            image.alt = item.product_title || item.title || '';
            image.width = 80;
            image.height = 80;
            image.loading = 'lazy';
            row.appendChild(image);
          }

          var info = document.createElement('div');
          info.className = 'cart-drawer__item-info';

          var title = document.createElement('p');
          title.className = 'cart-drawer__item-title';
          title.textContent = item.product_title || item.title || '';
          info.appendChild(title);

          if (item.variant_title && item.variant_title !== 'Default Title') {
            var variant = document.createElement('p');
            variant.className = 'cart-drawer__item-variant';
            variant.textContent = item.variant_title;
            info.appendChild(variant);
          }

          var price = document.createElement('p');
          price.className = 'cart-drawer__item-price';
          price.textContent = formatMoney(item.final_line_price, cart.currency);
          info.appendChild(price);

          row.appendChild(info);
          body.appendChild(row);
        });
      })
      .catch(function () {
        /* Keep the server-rendered drawer if the Ajax refresh is unavailable. */
      });
  }

  observeOverlay(mobileNav);
  observeOverlay(cartDrawer);

  if (cartDrawer && 'MutationObserver' in window) {
    var cartObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'data-open' && isOpen(cartDrawer)) {
          refreshCartDrawer();
        }
      });
    });
    cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['data-open'] });
  }

  if (mobileNav) {
    mobileNav.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (link) closeMobileNav();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var hadOpenOverlay = isOpen(mobileNav) || isOpen(cartDrawer);
    closeMobileNav();
    closeCartDrawer();
    syncOverlayState();
    if (hadOpenOverlay && lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
      lastFocused = null;
    }
  });

  syncOverlayState();
})();